<SettingsLayout page='settings/instances/add' label={pageLabel}>
  <h1 id="add-an-instance-h1">{pageLabel}</h1>

  <div class="add-new-instance">
    <form on:submit='onSubmitInstance(event)' aria-labelledby="add-an-instance-h1">

      {#if !hasIndexedDB || !hasLocalStorage}
        <div class="form-error form-error-user-error" role="alert">
          It seems Semaphore cannot store data locally. Is your browser in private mode or blocking cookies? Semaphore stores all data locally, and requires LocalStorage and IndexedDB to work correctly.
        </div>
      {/if}

      {#if $logInToInstanceError && $logInToInstanceErrorForText === $instanceNameInSearch}
        <div class="form-error form-error-user-error" role="alert">
          Error: {@html $logInToInstanceError}
        </div>
      {/if}

      <noscript>
        <div class="form-error" role="alert">
          You must enable JavaScript to log in.
        </div>
      </noscript>

      <label for="instanceInput">Instance:</label>
      <input type="text" inputmode="url" autocapitalize="none" spellcheck="false" id="instanceInput"
             bind:value='$instanceNameInSearch' placeholder="Enter instance name" required
      >
      <button class="primary" type="submit" id="submitButton"
              disabled={!$instanceNameInSearch || $logInToInstanceLoading}>
        Log in
      </button>
    </form>
  </div>

  {#if !$isUserLoggedIn}
    <p>
      Don't have an
      <Tooltip
        text="instance"
        tooltipText="An instance is your Mastodon home server, such as mastodon.social or cybre.space."
      />
      ?
      <a rel="noopener" target="_blank" href="https://joinmastodon.org">Join Mastodon!</a>
    </p>
  {/if}
</SettingsLayout>
<style>
  .add-new-instance {
    background: var(--form-bg);
    padding: 5px 10px 15px;
    margin: 20px auto;
    border: 1px solid var(--form-border);
    border-radius: 4px;
  }

  .form-error {
    border: 2px solid var(--warn-color);
    border-radius: 2px;
    padding: 10px;
    font-size: 1.3em;
    margin: 5px;
    background-color: var(--main-bg);
  }
  input {
    min-width: 70%;
    max-width: 100%;
    background-color: var(--input-bg);
  }

  label, input, button, :global(.add-new-instance-aside) {
    display: block;
    margin: 20px 5px;
  }

  @media (max-width: 767px) {
    input {
      min-width: 95%;
    }
  }

</style>
<script>
  import SettingsLayout from '../../../_components/settings/SettingsLayout.html'
  import { store } from '../../../_store/store.js'
  import { logInToInstance, handleOauthCode } from '../../../_actions/addInstance.js'
  import { testHasIndexedDB, testHasLocalStorage } from '../../../_utils/testStorage.js'
  import Tooltip from '../../../_components/Tooltip.html'

  export default {
    async oncreate () {
      const params = new URLSearchParams(location.search)
      const code = params.get('code')
      if (code) {
        await handleOauthCode(code)
      } else {
        this.set({
          hasIndexedDB: await testHasIndexedDB(),
          hasLocalStorage: testHasLocalStorage()
        })
      }
    },
    components: {
      SettingsLayout,
      Tooltip
    },
    store: () => store,
    data: () => ({
      hasIndexedDB: true,
      hasLocalStorage: true
    }),
    computed: {
      pageLabel: ({ $isUserLoggedIn }) => $isUserLoggedIn ? "Add instance" : "Log in"
    },
    methods: {
      onSubmitInstance (event) {
        event.preventDefault()
        event.stopPropagation()
        logInToInstance()
      }
    }
  }
</script>
